export const saveContent = (data: any, id: any, text: any) => {
  if (typeof data?.onContentUpdate === 'function') {
    data.onContentUpdate(id, text);
  } else {
    console.error("onContentUpdate is not defined or not a function");
  }
};

export const handleRemoveSingleConnected = (data: any, id: any) => {
  if (typeof data.onRemoveSingleConnected === 'function') {
    data.onRemoveSingleConnected(id); // Call the parent function to remove connected nodes
  } else {
    console.error('onRemoveSingleConnected is not a function:', data.onRemoveSingleConnected);
  }
};

export const handleDeLinkNode = (data: any, id: any) => {
  if (typeof data.onDeLink === 'function') {
    data.onDeLink(id);
  } else {
    console.error('onDeLink is not a function:', data.onDeLink);
  }
};

export const handleAdd = (type: any, data: any, id: any) => {
  if (typeof data.onAdd === 'function') {
    data.onAdd(id, type);
  } else {
    console.error('onAdd is not a function:', data.onAdd);
  }
};

export const handleRemoveConnected = (data: any, id: any) => {
  if (typeof data.onRemoveConnected === 'function') {
    data.onRemoveConnected(id); // Call the parent function to remove connected nodes
  } else {
    console.error('onRemoveConnected is not a function:', data.onRemoveConnected);
  }
};

export const checkParentNodeConnections = (nodes: any, edges: any): {
  isValid: boolean;
  orphanedNodes: string[];
  parentNodes: string[];
} => {
  const parentNodes = nodes
    .filter((node: any) => node?.type === 'questionNode' && node?.data?.label === 'parentNode')
    .map((node: any) => node?.id);

  if (parentNodes.length === 0) {
    return {
      isValid: false,
      orphanedNodes: nodes?.map((node: any) => node?.id),
      parentNodes: []
    };
  }

  const adjacencyList: Record<string, string[]> = {};
  nodes.forEach((node: any) => {
    adjacencyList[node.id] = [];
  });

  edges.forEach((edge: any) => {
    if (adjacencyList[edge.source]) {
      adjacencyList[edge.source].push(edge.target);
    }
    if (adjacencyList[edge.target]) {
      adjacencyList[edge.target].push(edge.source);
    }
  });

  // Track visited nodes from each parent node
  const visitedNodes = new Set<string>();

  // DFS function to traverse the graph
  const dfs = (nodeId: string) => {
    visitedNodes.add(nodeId);
    const neighbors = adjacencyList[nodeId] || [];
    for (const neighbor of neighbors) {
      if (!visitedNodes.has(neighbor)) {
        dfs(neighbor);
      }
    }
  };

  // Start DFS from each parent node
  parentNodes.forEach((parentId: any) => {
    dfs(parentId);
  });

  // Find orphaned nodes (nodes not connected to any parent)
  const orphanedNodes = nodes
    .map((node: any) => node.id)
    .filter((nodeId: any) => !visitedNodes.has(nodeId));

  return {
    isValid: orphanedNodes.length === 0,
    orphanedNodes,
    parentNodes
  };
};

export const validateUserInput = (input: string) => {
  // avoid initial empty spaces & extra spaces & restrict non-ASCII values using regex
  input = input.replace(/^\s+/, '');
  input = input.replace(/\s{2,}/g, ' ');
  const filter = input.replace(/[^\x00-\x7F]/g, "")
  return filter;
}